module.exports = __webpack_public_path__ + "img/P150T_weapon_51.ab15d78b.png";